export enum AttributeGroupTypes {
  ProductLabelAttributes = 'PRODUCT_LABEL_ATTRIBUTES',
}
